import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BackdropLoader } from '@livable/saas-react-components';
import { Typography, List, ListItem, Paper } from '@mui/material';
// import { useStore } from 'src/stores';
import useStyles from './styles';
const fakeData = ['{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}', 'Dec 30, 2020 07:52 by Wade Warren - Move-out: 01/01/2021 + Automatic FSE', '{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}', '{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}', 'Dec 30, 2020 07:52 by Leslie Alexander - Change occupancy: 0 → 1', 'Dec 30, 2020 07:52 by Leslie Alexander - Change occupancy: 0 → 1', '{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}', '{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}', '{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}', '{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}', '{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}', '{Time stamp Day + Time} by {Who did the activity} - {Activity type}: {Activity result}'];
export default function ActivityLogTab() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  // const store = useStore();

  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];

  // const getActivityLogs = async data => {
  //   const resp = await store.activity.getActivityLogsAsync.run(
  //     data
  //   );
  //   return resp;
  // };

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('unit_modal.last_activities', {
    count: 12
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, fakeData.map((activity, i) => /*#__PURE__*/React.createElement(ListItem, {
    key: i
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, activity)))))));
}